import { BANNER_LAYOUT_ROLES, type BannerLayoutKind } from '../../../features/bannerLayout/roles';
import styles from './BannerLayout.module.css';

/** パレットの並び (ビジュアル → 文字の順)。役割カタログ (roles.ts) の並びとは別に持つ */
const PALETTE_ORDER: readonly BannerLayoutKind[] = ['product', 'logo', 'main_copy', 'text', 'cta', 'price', 'date', 'disclaimer'];

/** 役割カタログのパレット。クリックで既定サイズを中央に追加 (同種は何個でも) */
export function BannerLayoutPalette({
  onAdd,
  disabledKinds,
  full,
  variant = 'column',
}: {
  onAdd: (kind: BannerLayoutKind) => void;
  /** kind → 無効の理由 */
  disabledKinds: Partial<Record<BannerLayoutKind, string>>;
  /** 要素が上限に達している */
  full: boolean;
  /** column = 縦一列 (旧)、row = ツールバーに並べるチップ (2026-10-18 の使いやすさ改善) */
  variant?: 'column' | 'row';
}) {
  return (
    <div className={variant === 'row' ? styles.paletteRow : styles.palette} data-testid="banner-layout-palette">
      <span className={styles.paletteTitle}>パーツを追加</span>
      {PALETTE_ORDER.map((kind) => {
        const role = BANNER_LAYOUT_ROLES[kind];
        const reason = full ? '要素は12個までです' : disabledKinds[kind];
        return (
          <button
            key={kind}
            type="button"
            className={styles.paletteButton}
            onClick={() => onAdd(kind)}
            disabled={!!reason}
            title={reason}
            data-testid={`banner-layout-palette-${kind}`}
          >
            <span className={styles.swatch} style={{ borderColor: role.color, borderStyle: kind === 'logo' ? 'dashed' : 'solid' }} />
            {role.label}
          </button>
        );
      })}
    </div>
  );
}
